const getPrice = number =>
  Intl.NumberFormat('de-DE', {
    currency: 'EUR',
    minimumFractionDigits: 2,
    style: 'currency'
  }).format(parseFloat(number ? number : 0))

export default getPrice
